import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallbackTitle?: string;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('[SPIN TENET ErrorBoundary Caught]:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '24px', border: '2px solid #e53e3e', background: '#fff5f5', color: '#9b2c2c', fontFamily: 'monospace' }}>
          <h3>{this.props.fallbackTitle || 'Boundary Execution Error'}</h3>
          <p>{this.state.error?.message}</p>
          <pre>{this.state.error?.stack}</pre>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{ padding: '6px 12px', background: '#e53e3e', color: '#fff', border: 'none', cursor: 'pointer' }}
          >
            Reset Boundary
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
